<app-yes-no-dialog-box [visible]="isVisible" (actionComplete)="cancel()"
    header="{{'image-cropper-popup.header'|translate }}"
    content="Select area that you like to crop then approve by clicking save button" customContent="true" size="medium">

    <div content>
        <image-cropper [imageFile]="image" [maintainAspectRatio]="true" [aspectRatio]="aspectRatio" [resizeToWidth]="480" [cropperMinWidth]="256"
            [onlyScaleDown]="true" [roundCropper]="roundCropper" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" [transform]="transform"></image-cropper>
        <div *ngIf="croppedImage" class="image-params">{{'image-cropper-popup.image-size-label'|translate}} {{croppedImageSizeInMegabytes |
            number:'3.1-2'}}
            {{'image-cropper-popup.image-size-unit'|translate}}</div>
        <!-- Image size: -->
        <div class="buttons">
            <div class="left">
                <button class="round-icon-button" (click)="rotateLeft()" data-test="image-cropper-rotate-left"><i class="fas fa-undo"></i></button>
                <button class="round-icon-button" (click)="rotateRight()" data-test="image-cropper-rotate-right"><i class="fas fa-redo"></i></button>
                <button class="round-icon-button" (click)="flipHorizontal()" data-test="image-cropper-flip-horizontal"><i class="fas fa-arrows-alt-h"></i></button>
                <button class="round-icon-button" (click)="flipVertical()" data-test="image-cropper-flip-vertical"><i class="fas fa-arrows-alt-v"></i></button>
            </div>

            <div class="right">
                <button class="btn btn-primary" (click)="save()" [translate]="'image-cropper-popup.save-button'"
                        data-test="image-cropper-button-ok"></button>
                <button class="btn btn-primary cancel" (click)="cancel()" [translate]="'image-cropper-popup.cancel-button'"
                        data-test="image-cropper-button-cancel"></button>
            </div>
        </div>

        <app-loader *ngIf="isLoading"></app-loader>
    </div>
</app-yes-no-dialog-box>
